import { render } from "./IntelligenceScreen.vue?vue&type=template&id=081d0756&scoped=true"
import script from "./IntelligenceScreen.vue?vue&type=script&lang=js"
export * from "./IntelligenceScreen.vue?vue&type=script&lang=js"

import "./IntelligenceScreen.vue?vue&type=style&index=0&id=081d0756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081d0756"]])

export default __exports__